import { FC } from 'react';

import RatioImage from '../ratio-image/ratio-image';
import styles from './business-hub-image-block-full.module.scss';

export interface ImageBlockFullProps {
    ratio?: number | 'auto';
    image?: string;
    maxHeight?: number;
    maxWidth?: number;
    minHeight?: number;
}

const BusinessHubImageBlockFull: FC<ImageBlockFullProps> = (props) => {
    const { image, maxWidth, maxHeight, ratio } = props;

    return (
        <div className={styles.container}>
            <div className={styles.wrapperImage}>
                <RatioImage image={image} ratio={ratio} maxWidth={maxWidth} maxHeight={maxHeight} />
            </div>
        </div>
    );
};

export default BusinessHubImageBlockFull;
